import { graphql } from "../generated/gql";

export const GetCallAIActions = graphql(
  `
    query GetCallAIActions($callSid: String!) {
      getCallTimelineByCallSidV2(callSid: $callSid) {
        __typename
        ... on GetTypedCallTimelineOutputV2 {
          events {
            __typename
            ... on VoiceVirtualAgentAIActionEvent {
              actionId
              occurredAt
              duration
              status
              errorCategory
              applicationName
              integrationName
              iconUrl
              inputParams
              outputParams
            }
          }
        }
      }
    }
  `
);
